import * as React from "react";

import {
  PRESENTATION_SCROLL_ACTIONS,
  usePresenterForScroll,
} from "../../Common";

import {
  usePlpPresenterForTheProductsMasonry,
  useProductListAutoInitialization,
  useProductListLoadingState,
  useProductListPresentationModel,
  useProductListRestoreScroll,
} from "../providers";

import { Product } from "./Product";
import {
  BANNER_ROW_IDENTIFIER,
  BANNER_TILE_IDENTIFIER,
} from "../providers/product-list-provider/product-list-utils";

export const ProductMasonry: React.FunctionComponent = () => {
  const { scrollActionToTake, onScrollAnimationBegin } =
    usePresenterForScroll();

  const { hasInitialized } = useProductListAutoInitialization();
  const { isLoading: isTheProductListLoading } = useProductListLoadingState();
  const { presentationProducts } = useProductListPresentationModel();
  const {
    getAdditionalClassNameToRenderForEachProductItem,
    handleAfterFirstMasonryRender,
  } = useProductListRestoreScroll();

  const { numberOfColumnsToDisplay } = usePlpPresenterForTheProductsMasonry();

  const [isFirstRender, setIsFirstRender] = React.useState(true);

  React.useEffect(() => {
    if (hasInitialized && isFirstRender) {
      handleAfterFirstMasonryRender();
      setIsFirstRender(false);
    }
  }, [hasInitialized, isFirstRender]);

  const getRenderedTopElement = (): [Element, boolean] | undefined => {
    let element = window.document.querySelector(
      `.bbnt-plp-page-contents .mobile-applied-filters`,
    );
    if (element) {
      return [element, true];
    }
    element = window.document.querySelector(
      `.bbnt-plp-page-contents .mobile-info-bar.actually-on-a-mobile`,
    );
    if (element) {
      return [element, true];
    }
    element = window.document.querySelector(
      `.bbnt-plp-page-contents .desktop-action-bar`,
    );
    if (element) {
      return [element, false];
    }
    return undefined;
  };
  const scrollToJustAbove = (element: Element, margin: number = 20) => {
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect + window.pageYOffset;
    const offsetPosition = elementPosition - margin;

    window.scrollTo({ top: offsetPosition });
  };
  const scrollToTop = () => {
    const renderedResult = getRenderedTopElement();
    if (renderedResult) {
      const [element, isMobile] = renderedResult;
      scrollToJustAbove(element, isMobile ? 170 : 145);
    }

    onScrollAnimationBegin();
  };
  React.useEffect(() => {
    if (
      !isTheProductListLoading &&
      scrollActionToTake === PRESENTATION_SCROLL_ACTIONS.SCROLL_TO_TOP
    ) {
      scrollToTop();
    }
  }, [isTheProductListLoading, scrollActionToTake]);

  const sendFHInteractions = (
    url: string,
    fh_name: string,
    fh_slogan: string,
  ) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "PLP_Inline_Banner",
      banner_url: url,
      banner_name: fh_name,
      banner_slogan: fh_slogan,
      banner_page_url: window.location.href,
    });
  };
  const products = React.useMemo(() => {
    return presentationProducts.map((product, index) => {
      return product.id === BANNER_TILE_IDENTIFIER ||
        product.id === BANNER_ROW_IDENTIFIER ? (
        <div className={product.id}>
          <a
            href={product.url}
            onClick={() => {
              sendFHInteractions(
                product.url,
                product.fh_name,
                product.fh_slogan,
              );
            }}
          >
            <img className="banner-img" src={product.imageUrl} />
          </a>
        </div>
      ) : (
        <li
          key={product.id}
          className={`product ${getAdditionalClassNameToRenderForEachProductItem(
            product,
          )}`}
        >
          <Product product={product} index={index} />
        </li>
      );
    });
  }, [presentationProducts]);

  let columnsClass;
  switch (numberOfColumnsToDisplay) {
    case 2:
      columnsClass = "columns-2";
      break;
    case 3:
      columnsClass = "columns-3";
      break;
    case 4:
      columnsClass = "columns-4";
      break;
    default:
      columnsClass = "columns-1";
      break;
  }

  return <ul className={`product-masonry ${columnsClass}`}>{products}</ul>;
};
